// extracted by mini-css-extract-plugin
export default {"menuBlock":"aE-z","title":"bE-z","nav":"cE-z","flexCell":"dE-z","facetLink":"eE-z"};